module.exports = __webpack_public_path__ + "static/media/luka_headshot.72788065.png";